
const digest = '6b95df3f2ac982876a0bf4b760c52d389acc12379e7405343d9768644650f4fc';
const css = `._anchorCopyLinkWrapper_v7e9h_1 {
  position: absolute;
  margin-left: 0;
  transition: opacity 150ms 150ms, margin 200ms 150ms;
  opacity: 0;
  user-select: none;
}

._anchorCopyLinkContainer_v7e9h_9:hover ._anchorCopyLinkWrapper_v7e9h_1 {
  opacity: 0.5;
  margin-left: var(--spacer-2);
}

._anchorCopyLinkWrapper_v7e9h_1:hover {
  opacity: 1 !important;
  transition: none;
}

._anchorCopyLink_v7e9h_1 {
  font-size: 0.97rem;
  color: var(--theme-secondary-text);
  cursor: pointer;
  text-decoration: none;
  vertical-align: middle;
}

._anchorCopyLink_v7e9h_1::after {
  /* I'm manually inserting the Font Awesome icon here because if we use */
  /* an 'i' tag (with ::before), it breaks certain cases for */
  /* text-highlighting in Chrome. */

  content: '\\f0c1'; /* fa-link */
  font-family: 'Font Awesome 6 Pro';
  font-weight: 400;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"anchorCopyLinkWrapper":"_anchorCopyLinkWrapper_v7e9h_1","anchorCopyLinkContainer":"_anchorCopyLinkContainer_v7e9h_9","anchorCopyLink":"_anchorCopyLink_v7e9h_1"};
export { css, digest };
  